import { QFilter } from '@/types';
import { SearchTreeNode } from '@/types/searchTreeTypes';
import { DomainCode } from '@australiangreens/ag-internal-components';
import { logger } from '@/util';
import callBackendApi from './call';

export interface TagRecord {
  id: number;
  label: string;
}

export const getTagsByIds = async (
  token: string,
  tagIds: number[],
  domainCode: DomainCode,
  abortSignal?: AbortSignal
) => {
  logger.debug('getTagsByIds() called', {});

  const data = await callBackendApi({
    token,
    method: 'get',
    endpoint: `/tags?ids=${JSON.stringify(tagIds)}&domainCode=${domainCode}`,
    abortSignal,
  });
  return data as TagRecord[];
};

export const getTagsContaining = async (
  token: string,
  containedString: string,
  domainCode: DomainCode,
  abortSignal?: AbortSignal
) => {
  logger.debug('getTagsContaining() called', {});

  const data = await callBackendApi({
    token,
    method: 'get',
    endpoint: `/tags/containing/${encodeURIComponent(containedString)}?domainCode=${domainCode}`,
    abortSignal,
  });
  return data as TagRecord[];
};

export const getTagByLabel = async (token: string, tagLabel: string, abortSignal?: AbortSignal) => {
  logger.debug('getTagByLabel() called', {});

  const data = await callBackendApi({
    token,
    method: 'get',
    endpoint: `/tags/getbylabel/${encodeURIComponent(tagLabel)}`,
    abortSignal,
  });
  return data as TagRecord[];
};

export const addToTags = async (
  token: string,
  values: { qFilter: QFilter; tagIds: number[]; domainCode: DomainCode }
) => {
  logger.debug('addToTags() called', {});

  const data = await callBackendApi({
    token,
    method: 'post',
    endpoint: '/addtotags',
    data: values,
  });

  return data;
};

export type AddToTagsAdvData = {
  tree: SearchTreeNode;
  addToTagIds: number[];
  domainCode: DomainCode;
};

// [LIST-680]
export const addToTagsAdv = async (token: string, data: AddToTagsAdvData) =>
  callBackendApi({
    token,
    method: 'post',
    endpoint: '/addtotags/adv',
    data,
  });

export const removeFromTags = async (
  token: string,
  values: { qFilter: QFilter; tagIds: number[]; domainCode: DomainCode }
) => {
  logger.debug('removeFromTags() called', {});

  const data = await callBackendApi({
    token,
    method: 'put',
    endpoint: '/removefromtags',
    data: values,
  });

  return data;
};

export type RemoveFromTagsAdvData = {
  tree: SearchTreeNode;
  removeFromTagIds: number[];
  domainCode: DomainCode;
};

// [LIST-680]
export const removeFromTagsAdv = async (token: string, data: RemoveFromTagsAdvData) =>
  callBackendApi({
    token,
    method: 'put',
    endpoint: '/removefromtags/adv',
    data,
  });
